import planetCodeFullConversion from "../data/planetCodeFullConversion";
import planetCodeShort from "../data/planetCodeShort";
import { decimalToDegreesMinutes } from "./decimaltoDegrees";
import maliBeneNeuMaliBeniEmoji from "../data/MaliBeneNeu";
import marakaBhadhakaEmoji from "../data/MarakaBhaka";
import exhalDebiEmoji from "../data/ExhaDebi";
import houseBaseCoordinates from "../data/baseCoordinates";
import { getPositionOfAscendantInDivisionalChart } from "./getAscPositionDivChart";

export const divisionalChartGenerator = (responseData, retroData) => {
  let planetData = {};

  responseData.divisional_positions.forEach((houseDataBlock) => {
    const { rasi, planet_positions } = houseDataBlock;

    const houseNumber = parseInt(rasi.id) + 1;

    if (!planetData[houseNumber]) {
      planetData[houseNumber] = {};
    }

    planet_positions.forEach((grahaDataBlock) => {
      planetData[houseNumber][
        planetCodeFullConversion[grahaDataBlock.planet.id]
      ] = {
        degree: decimalToDegreesMinutes(grahaDataBlock.sign_degree),
        isRetro: retroData[grahaDataBlock.planet.id],
        emoji1:
          maliBeneNeuMaliBeniEmoji[
            getPositionOfAscendantInDivisionalChart(
              responseData.divisional_positions
            )
          ][planetCodeFullConversion[grahaDataBlock.planet.id]],
        emoji2:
          marakaBhadhakaEmoji[
            getPositionOfAscendantInDivisionalChart(
              responseData.divisional_positions
            )
          ][planetCodeFullConversion[grahaDataBlock.planet.id]],
        emoji3:
          exhalDebiEmoji[parseInt(grahaDataBlock.rasi.id) + 1][
            planetCodeFullConversion[grahaDataBlock.planet.id]
          ],
        color: "black",
        nakshatra: grahaDataBlock.nakshatra.id,
        nakshatraLord: grahaDataBlock.nakshatra.lord.id,
        planetName: retroData[grahaDataBlock.planet.id]
          ? `(${planetCodeShort[grahaDataBlock.planet.id]})`
          : planetCodeShort[grahaDataBlock.planet.id],
      };
    });
  });

  const planetCurrentHouse = {};
  for (const house in planetData) {
    const planets = planetData[house];
    for (const planet in planets) {
      planetCurrentHouse[planets[planet].planetName] = house;
    }
  }

  const convertedData = {};

  for (const key in planetData) {
    const formattedValues = [];
    for (const planet in planetData[key]) {
      const details = planetData[key][planet];

      formattedValues.push({
        planetNameX: details.planetName,
        planetDegreeX: details.degree,
        planetEmojiX1: details.emoji1,
        planetEmojiX2: details.emoji2,
        planetEmojiX3: details.emoji3,
      });
    }
    convertedData[key] = formattedValues;
  }

  function calculateCoordinates(
    houseNumber,
    convertedData,
    houseBaseCoordinates
  ) {
    const x0 = parseInt(houseBaseCoordinates[houseNumber].x0);
    const y0 = parseInt(houseBaseCoordinates[houseNumber].y0);
    const numberOfPlanets = convertedData[houseNumber].length;
    const coordinates = [];

    for (let i = 1; i <= numberOfPlanets; i++) {
      const xn = x0 + 116 / 2;
      const yn = y0 + (116 / (numberOfPlanets + 1)) * i;

      const width = 96;
      // const height = 116 - 5 * (numberOfPlanets + 1);  it was before
      const height = (116 * 0.95) / (numberOfPlanets + 1);
      const xstart = x0 + 10;

      //  const ystart = numberOfPlanets * 1.6 + yn - height / 2;  i thought to change to ,
      const ystart = yn - height / 2;

      coordinates.push({
        label: convertedData[houseNumber][i - 1],
        x: xn.toFixed(1),
        y: yn.toFixed(1),
        fontSize: numberOfPlanets > 4 ? 14 : 16,
        houseNumber: houseNumber,
        xOri: xstart.toFixed(1),
        yOri: ystart.toFixed(1),
        width: width.toFixed(1),
        height: height.toFixed(1),
      });
    }

    return coordinates;
  }

  function calculateAllCoordinates(convertedData, houseBaseCoordinates) {
    let allCoordinates = [];

    for (let key in convertedData) {
      const houseNumber = key;
      const coordinates = calculateCoordinates(
        houseNumber,
        convertedData,
        houseBaseCoordinates
      );
      allCoordinates = allCoordinates.concat(coordinates);
    }

    return allCoordinates;
  }

  const allCoordinates = calculateAllCoordinates(
    convertedData,
    houseBaseCoordinates
  );

  return allCoordinates;
};
